import React from "react";

export interface JamroomIconButtonProps {
  iconId: string;
  ariaLabel: string;
  pressed?: boolean;
  danger?: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  size?: number;
  className?: string;
  title?: string;
}

function toHref(iconId: string): string {
  const v = String(iconId || "").trim();
  if (!v) return "";
  return v.startsWith("#") ? v : `#${v}`;
}

const JamroomIconButton: React.FC<JamroomIconButtonProps> = ({
  iconId,
  ariaLabel,
  pressed,
  danger,
  disabled,
  onClick,
  size,
  className,
  title,
}) => {
  const href = toHref(iconId);
  const resolvedTitle = title || ariaLabel;

  const classes = ["jr-btn", "jr-jam-btn"];
  if (danger) classes.push("is-danger");
  if (className) classes.push(className);

  const style =
    typeof size === "number" && Number.isFinite(size)
      ? ({
          // Reuse the variables from the provided buttons pack.
          // Keep icon size proportional.
          ["--jr-btn" as any]: `${Math.max(28, Math.round(size))}px`,
          ["--jr-icon" as any]: `${Math.max(14, Math.round(size * 0.42))}px`,
        } as React.CSSProperties)
      : undefined;

  return (
    <button
      type="button"
      className={classes.join(" ")}
      aria-label={ariaLabel}
      aria-pressed={pressed ? "true" : undefined}
      disabled={disabled}
      title={resolvedTitle}
      onClick={onClick}
      style={style}
    >
      <svg aria-hidden="true" focusable="false">
        {href ? <use href={href} /> : null}
      </svg>
    </button>
  );
};

export default JamroomIconButton;

